import { useLazyQuery, useQuery } from '@apollo/client'
import type {
  ApolloError,
  LazyQueryExecFunction,
  OperationVariables,
} from '@apollo/client'
import { IGraphqlQueryProps } from '@dtos/Pagination'
import { IActivityData } from '@dtos/Activity'
import {
  GET_ACTIVITY,
  GET_ACTIVITY_EXAM_QUESTIONS,
} from './queries/getActivities'

interface IGetActivityProps {
  courseId: number
  enrollmentId: number
  id: number
}

interface IGetActivityResult {
  data: IActivityData | undefined
  loading: boolean
  error: ApolloError | undefined
  getActivity: LazyQueryExecFunction<IActivityData, OperationVariables>
}

export const useGetActivity = ({
  courseId,
  enrollmentId,
  id,
}: IGetActivityProps): IGetActivityResult => {
  const [get, { data, loading, error }] = useLazyQuery<IActivityData>(
    GET_ACTIVITY,
    {
      variables: { courseId, enrollmentId, id },
      fetchPolicy: 'network-only',
    },
  )

  return { data, loading, error, getActivity: get }
}

interface IGetActivityExamQuestionsProps {
  activityId: number
  pagination: IGraphqlQueryProps
}

export const useGetActivityExamQuestions = ({
  activityId,
  pagination,
}: IGetActivityExamQuestionsProps) => {
  const { data, loading, error } = useQuery(GET_ACTIVITY_EXAM_QUESTIONS, {
    variables: { activityId, pagination },
  })

  return { data, loading, error }
}
